import { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { UserContext } from "./user.context";

const PrivateRoutes = () => {
  const { user } = useContext(UserContext);

  return user ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
